import { cn } from "@babybjorn/ui";
import type { FC, HTMLAttributes, PropsWithChildren } from "react";
import * as s from "./GridContainer.module.scss";

type GridContainerProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		className?: string;
	}
>;

const GridContainer: FC<GridContainerProps> = ({
	children,
	className,
	...rest
}) => (
	<div className={cn(s.grid, className)} {...rest}>
		{children}
	</div>
);

export default GridContainer;
